import React from 'react'
import PropTypes from 'prop-types'

const Readme = props => {
    return (
        <div className='readme_body'>
            <main>
                <h1 id="revature-p1-backend">Inventory Management System - Java Backend</h1>
<p>This is a Java Spring Boot backend application that supports a product-based system with JWT-protected authentication (i.e. Inventory Management System Backend API). It is connected to a PostgreSQL database (via Docker), supports user registration and login using bcrypt password hashing, and protects all product-related routes with JSON Web Tokens.</p>
<p><img src="https://github.com/tunde262/Backend_API_Java_Spring_PostgreSQL/blob/main/assets/thumbnail.png?raw=true" alt="thumbnail" /></p>
<hr />
<h2 id="tech-stack">Tech Stack</h2>
<ul>
<li><strong>Java</strong></li>
<li><strong>Spring Boot</strong></li>
<li><strong>Spring Web</strong></li>
<li><strong>PostgreSQL</strong> (via Docker)</li>
<li><strong>JDBC Template</strong></li>
<li><strong>JWT</strong></li>
<li><strong>BCrypt</strong></li>
</ul>
<hr />
<h2 id="authentication--security">Authentication &amp; Security</h2>
<ul>
<li><strong>JWT-based Authentication</strong><ul>
<li>Login and registration return a JWT token.</li>
<li>All <code>/api/products/**</code> routes are protected via middleware that decodes the JWT.</li></ul></li>
<li><strong>Password Hashing</strong><ul>
<li>Passwords are hashed with <code>BCrypt</code> before storing in the database.</li></ul></li>
</ul>
<hr />
<h2 id="features">Features</h2>
<h3 id="user-endpoints-apiusers">User Endpoints (<code>/api/users</code>)</h3>
<table>
<thead>
<tr>
<th id="method">Method</th>
<th id="endpoint">Endpoint</th>
<th id="description">Description</th>
<th id="auth">Auth</th>
</tr>
</thead>
<tbody>
<tr>
<td>POST</td>
<td><code>/register</code></td>
<td>Register new user</td>
<td>❌</td>
</tr>
<tr>
<td>POST</td>
<td><code>/login</code></td>
<td>Login and get JWT token</td>
<td>❌</td>
</tr>
<tr>
<td>GET</td>
<td><code>/me</code></td>
<td>Get current user profile</td>
<td>✅</td>
</tr>
</tbody>
</table>
<h3 id="product-endpoints-apiproducts">Product Endpoints (<code>/api/products</code>)</h3>
<table>
<thead>
<tr>
<th id="method">Method</th>
<th id="endpoint">Endpoint</th>
<th id="description">Description</th>
<th id="auth">Auth</th>
</tr>
</thead>
<tbody>
<tr>
<td>GET</td>
<td><code>/</code></td>
<td>Fetch all products or search</td>
<td>✅</td>
</tr>
<tr>
<td>GET</td>
<td><code>/:productId</code></td>
<td>Fetch product by ID</td>
<td>✅</td>
</tr>
<tr>
<td>POST</td>
<td><code>/</code></td>
<td>Add new product</td>
<td>✅</td>
</tr>
<tr>
<td>PUT</td>
<td><code>/:productId</code></td>
<td>Update existing product</td>
<td>✅</td>
</tr>
<tr>
<td>DELETE</td>
<td><code>/:productId</code></td>
<td>Delete a product</td>
<td>✅</td>
</tr>
</tbody>
</table>
<hr />
<h2 id="running-the-app">Running the App</h2>
<h3 id="prerequisites">Prerequisites</h3>
<ul>
<li>Java 17</li>
<li>Maven</li>
<li>Docker (for PostgreSQL)</li>
</ul>
<h3 id="steps">Steps</h3>
<ol>
<li>Start PostgreSQL:</li>
</ol>
<pre><code class="hljs bash language-bash">docker container run --name revature-p1-database -e POSTGRES_PASSWORD=password -d -p 5431:5432 postgres</code></pre>
<ol start="2">
<li>Run Spring Boot app</li>
</ol>
<hr />
<h2 id="testing-backend-only">Testing (Backend Only)</h2>
<p>Use tools like Postman or Hoppscotch to test:</p>
<ol>
<li><p>Register: <code>POST /api/users/register</code></p></li>
<li><p>Login: <code>POST /api/users/login</code></p></li>
<li><p>Use the returned JWT as <code>Authorization: Bearer &lt;token&gt;</code> header for all product requests.</p></li>
</ol>
            </main>
        </div>
  )
}

Readme.propTypes = {}

export default Readme;
